import FeatureIcon from './ListIcons/Diamond Full.svg';
import GroupIcon from './ListIcons/group-icon.png';
import VisualisedGroupIcon from './ListIcons/visualised-icon.png';
import TextNodeIcon from './ListIcons/text-icon.png';
import ProgressBarIcon from './ListIcons/progress-bar-icon.png';
import ImageNodeIcon from './ListIcons/image-icon.png';
import NodeClosedIcon from './ListIcons/node-closed.png';
import NodeOpenIcon from './ListIcons/node-open.png';
import AddIcon from './ListIcons/add-icon.png';
import CogIcon from './ListIcons/Settings.svg';
import AudioIcon from './ListIcons/Audio.svg';

import EyeOnIcon from './ModuleIcons/eye.png';
import EyeOffIcon from './ModuleIcons/eye_off.png';
import TextLeftAlignIcon from './ModuleIcons/Left.png';
import TextCenterAlignIcon from './ModuleIcons/Centre.png';
import TextRightAlignIcon from './ModuleIcons/Right.png';
import AlignTopIcon from './ModuleIcons/Top.png';
import AlignCenterIcon from './ModuleIcons/Middle.png';
import AlignBottomIcon from './ModuleIcons/Bottom.png';
import LineSpacingIcon from './ModuleIcons/format_line_spacing.png';
import ChevronDown from './ModuleIcons/keyboard_arrow_down.png';

export const WORKSPACE_LEFT_LIST_ICONS = {
    feature: FeatureIcon,
    basicGroup: GroupIcon,
    visualisedGroup: VisualisedGroupIcon,
    text: TextNodeIcon,
    progressBar: ProgressBarIcon,
    image: ImageNodeIcon,
    nodeClosed: NodeClosedIcon,
    nodeOpen: NodeOpenIcon,
    add: AddIcon,
    settings: CogIcon,
    audio: AudioIcon,
};

export const WORKSPACE_MODULE_ICONS = {
    eyeOn: EyeOnIcon,
    eyeOff: EyeOffIcon,
    textLeftAlign: TextLeftAlignIcon,
    textCenterAlign: TextCenterAlignIcon,
    textRightAlign: TextRightAlignIcon,
    alignTop: AlignTopIcon,
    alignCenter: AlignCenterIcon,
    alignBottom: AlignBottomIcon,
    lineSpacing: LineSpacingIcon,
    chevronDown: ChevronDown,
};

export const TIMELINE_ARROW_SVG = 
<svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 24L4 12H28L16 24Z" fill="#a04bdc"/>
</svg>;
